export default __webpack_public_path__ + "static/media/steelRailing.bbd54659.jpeg";